import React from 'react';
import TurfGroupCard from './TurfGroupCard';
import { useDoorCrewCard } from './DoorCrewCardContext';
import { groupSeatsByTurf } from './groupSeatsByTurf';

interface SeatListProps {
  color?: string;
}

export default function SeatList({ color }: SeatListProps) {
  const { crew } = useDoorCrewCard();
  const groups = groupSeatsByTurf(crew.seats);

  let seatOffset = 0;

  return (
    <div className="seat-wrapper">
      {groups.map((group) => {
        const card = (
          <TurfGroupCard
            key={`${group.turfId}-${group.seats[0].id}`}
            group={group}
            seatOffset={seatOffset}
            color={color}
          />
        );
        seatOffset += group.seats.length;
        return card;
      })}
    </div>
  );
}
